<!-- 
    File: cgp-notification-menu.template.html
    Author: Brandon Shreve
    Date: 10/25/2018
    Desc: Menu to display notifications
    Other Contributors:
-->

<button mat-icon-button color="primary" title="Notifications" [matMenuTriggerFor]="notificationsMenu">
    <i class="fa fa-bell-o tab-strip-menu-icon" [ngClass]="styleNotificationBell()"></i>
    <span *ngIf="getUnreadNotificationCount() > 0" class="notification-badge notification-badge-accent">{{getUnreadNotificationDisplayString()}}</span>
</button>
<mat-menu #notificationsMenu="matMenu" yPosition="below" xPosition="before" [overlapTrigger]="false" class="notifications-dropdown" disableRipple>
    <h1 class="notifications-header">Notifications</h1>
    <div *ngIf="notifications.length > 0; else elseBlock">  
        <div class="notifications-container">
            <div mat-menu-item *ngFor="let notification of notifications" [ngClass]="styleNotificationContainer(notification)"
                class="notification-row" (click)="$event.stopPropagation()">  
                <div>
                    <h2 [ngClass]="styleNotificationTitle(notification)" (click)="notificationClickHandler(notification)">{{notification.title}}</h2>
                    <p [ngClass]="styleNotificationMessage(notification)" (click)="notificationClickHandler(notification)">
                        {{notification.formattedMessage}}
                    </p>
                    <address *ngIf="notification.author" (click)="notificationClickHandler(notification)">{{notification.author}}</address>
                </div>
                <div class="delete-notification-container">
                    <time class="hover-toggle-on" [innerHTML]="notification.formattedDate"></time>
                    <button mat-icon-button class="delete-notification-button hover-toggle-off" (click)="updateNotification(notification, 'delete')">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <ng-template #elseBlock>
        <p class="no-notifications">You have no new notifications.</p>
    </ng-template>
</mat-menu>